/**
 * Single source of truth for South Africa (en-ZA) product buy URLs
 */
export const zaProductLinks = {
  'dolphin-s-300i': 'https://mydolphin.co.za/product/dolphin-s-300i/',
  'dolphin-S3000-pool-cleaner': 'https://mydolphin.co.za/product/dolphin-s3000-robot-pool-cleaner/',
  'dolphin-S1000-pool-cleaner': 'https://mydolphin.co.za/product/dolphin-s1000-robot-pool-cleaner/',
  'dolphin-m-600-pool-cleaner': 'https://mydolphin.co.za/product/dolphin-m-600/',
  'dolphin-eon-100-cordless-pool-cleaner': 'https://mydolphin.co.za/product/dolphin-eon-100-cordless-pool-cleaner/',
  'dolphin-eon-120d-cordless-pool-cleaner': 'https://mydolphin.co.za/product/dolphin-eon-120d-cordless-pool-cleaner/',
  'dolphin-m500-iot-wb': 'https://mydolphin.co.za/product/dolphin-m-500/',
  'dolphin-m500-iot-cb': 'https://mydolphin.co.za/product/dolphin-m-500/'
}

/**
 * Returns the South Africa redirect URL for a product slug
 * @param {string} slug
 * @returns {string}
 */
export const getZaBuyLink = (slug) => {
  return zaProductLinks[slug] || 'https://mydolphin.co.za'
}